import { getIdPrefixedObjectFromArray } from "../modifiers";
import { getChatOnSnapshotListenersArray } from "./getChatOnSnapshotListenersArray";

export const getChatOnSnapshotListenersObject = (chatIds: string[]) => {
  const chatListenersArray = getChatOnSnapshotListenersArray(chatIds);
  return getIdPrefixedObjectFromArray(chatListenersArray);
};
